import React from 'react';
import { useTranslation } from 'react-i18next';
import { SrOnly } from '../../styled-components/components/SrOnly';

interface TagGroupProps {
  onRemove?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
  title: string;
}

const TagGroup = ({ onRemove, children, title }: TagGroupProps) => {
  const { t } = useTranslation(['search']);

  return (
    <div className="filter-group">
      {onRemove && (
        <button
          type="button"
          className="filter-group-action"
          onClick={onRemove}
          title={t('removeSpecificFilterGroup', { name: title, ns: 'search' })}
        >
          <i className="icon-close no-margin" />
          <SrOnly>{t('removeSpecificFilterGroup', { name: title, ns: 'search' })}</SrOnly>
        </button>
      )}
      {children}
    </div>
  );
};

export default TagGroup;
